import React from "react";
import { Row, Col } from "react-flexbox-grid";
import Masonry from "react-masonry-css";
//Scss
import "./portfolio.scss";
//Assets
import Arrow from "../../assets/portfolio/arrow.svg";
import Preview1 from "../../assets/portfolio/project01/preview.png";
import Preview2 from "../../assets/portfolio/project02/preview.png";
import Preview3 from "../../assets/portfolio/project03/preview.png";
import Preview4 from "../../assets/portfolio/project04/preview.png";
import Preview5 from "../../assets/portfolio/project05/preview.png";
import Preview6 from "../../assets/portfolio/project06/preview.png";
import Preview7 from "../../assets/portfolio/project07/preview.png";
import Preview8 from "../../assets/portfolio/project08/preview.png";
//Components
import Button from "../ui-components/button/button";
import Title from "../ui-components/title/title";
import ProjectBox from "../ui-components/projectBox/projectBox";

class Portfolio extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // PORTFOLIO PROJECTS
      projects: [
        {
          id: "1",
          preview: Preview1,
          title: "18 bit RISC Processor",
          tag: "hardware",
          lang: "",
          link: "https://github.com/labibrah/18bitInstructionRISCProcessor",
          
        },
        {
          id: "2",
          preview: Preview2,
          title: "University Billing System",
          tag: "software",
          lang: "Java",
          link: "https://github.com/labibrah/UniversityBillingSystem",
        },
        {
          
          id: "3",
          preview: Preview3,
          title: "x86 Programming",
          tag: "software",
                lang: "Assembly",
          link: "https://github.com/labibrah/Assembly_lang",
        },
        {
          id: "4",
          preview: Preview4,
          title: "7 segment display",
          tag: "hardware",
          lang: "",
          link: "https://github.com/labibrah/7segdis",
        },
        {
          id: "5",
          preview: Preview5,
          title: "Whatsapp Bot",
          tag: "software",
                lang: "Python",
          link: "https://github.com/labibrah/whatsapp-bot",
        },
        {
          id: "6",
          preview: Preview6,
          title: "Aumtomated Parking Lot",
          tag: "software",
                lang: "C",
          link: "https://github.com/labibrah/Parking-system",
        },
        {
          id: "7",
          preview: Preview7,
          title: "Covi-BD",
          tag: "software",
                lang: "React JS",
          link: "https://github.com/labibrah/covi-bd",
        },
        {
          id: "8",
          preview: Preview8,
          title: "BatSignal",
          tag: "hardware",
                lang: "(Smart Lamp)",
          link: "https://github.com/labibrah/BatSignal",
        },
       
      ],
      // PORTFOLIO GALLERY WILL LOAD THIS AFTER FUNCTION "filterGallery" FINISH FILTERING
      filterResult: null,
      pickedFilter: "all",
      filterMenuActive: false,
      pickedFilterDropdown: "NEWEST"
    };
  }

  // FIRST LOAD
  componentDidMount() {
    this.filterGallery("all");
  }

  //FILTER PORTFOLIO FUNCTION
  filterGallery = (target) => {
    let projectsArr = [...this.state.projects];
    let result;

    if (target !== "all") {
      result = projectsArr.filter((project) => project.tag === target);
    } else {
      result = projectsArr;
    }

    this.setState({ filterResult: result, pickedFilter: target, pickedFilterDropdown: "NEWEST" });
  };

  // FILTER DROP DOWN HOVER MENU FUNCTION
  filterMenuHover = (event) => {
    if(event) {
      this.setState({ filterMenuActive: true });
    }else {
      this.setState({ filterMenuActive: false });
    }
  }

  // FILTER DROP DOWN HANDLER
  filterDropDownHandler = (filter) => {
    this.setState({ pickedFilterDropdown: filter, filterMenuActive: false });

    let projectsArr = [...this.state.filterResult];
    let result;

    if (filter === "NEWEST") {
      result = projectsArr.sort((a, b) => (a.id > b.id ? 1 : -1));
    }else if (filter === "OLDEST") {
      result = projectsArr.sort((a, b) => (a.id > b.id ? 1 : -1)).reverse();
    }

    this.setState({ filterResult: result});
  }

  //onclick
  onHandleClick = () => {
    
     

      //window.location.href = link;
      window.location.assign(this.link);
    
  }

  // RENDER

  render() {
    // PORTFOLIO GALLERY RENDER
    let projectsRender = null;
    if (this.state.filterResult) {
      projectsRender = this.state.filterResult.map((project) => (
        <ProjectBox preview={project.preview} key={project.id} title={project.title} tag={project.tag} lang={project.lang} link={project.link}/>
      ));
    }
    // PORTFOLIO GALLERY BREAKPOINTS
    const portfolioBreakpoints = {
      default: 3,
      1100: 3,
      700: 2,
      500: 1,
    };
    // PORTFOLIO FILTER DROPDOWN MENU RENDER
    let filterDroppDown = null;
    if(this.state.filterMenuActive) {
      filterDroppDown = (
        <div className="portfolio__filter-menu shadow">
          <p className="font12" onClick={() => this.filterDropDownHandler("NEWEST")}>
            NEWEST
          </p>
          <p className="font12" onClick={() => this.filterDropDownHandler("OLDEST")}>
            OLDEST
          </p>
        </div>
      );
    }

    return (
      <div id="portfolio">
        <div className="wrapper">
          <Title title="SOME PROJECTS" />
          <Row>
            <Col xs={12} sm={12} md={8} lg={9}>
              <div className="portfolio__nav">
                <ul>
                  <li className={this.state.pickedFilter === "all" ? "portfolio__nav-active font12" : "font12"} onClick={() => this.filterGallery("all")}>
                    ALL
                  </li>
                  <li
                    className={this.state.pickedFilter === "software" ? "portfolio__nav-active font12" : "font12"}
                    onClick={() => this.filterGallery("software")}
                  >
                    SOFTWARE
                  </li>
                  <li
                    className={this.state.pickedFilter === "hardware" ? "portfolio__nav-active font12" : "font12"}
                    onClick={() => this.filterGallery("hardware")}
                  >
                    HARDWARE
                  </li>
                </ul>
              </div>
            </Col>
            <Col xs={12} sm={12} md={4} lg={3}>
              <div className="portfolio__filter" onMouseEnter={() => this.filterMenuHover(true)} onMouseLeave={() => this.filterMenuHover(false)}>
                <p className="font12">{this.state.pickedFilterDropdown} FIRST</p>
                <img src={Arrow} alt="arrow" />
                {filterDroppDown}
              </div>
            </Col>
          </Row>
          <Masonry breakpointCols={portfolioBreakpoints} className="my-masonry-grid" columnClassName="mint__gallery">
            {projectsRender}
          </Masonry>
          
        </div>
      </div>
    );
  }
}

export default Portfolio;
